/**
 * Вміст десктопних меню (мегаменю + панель «Каталог») не вбудований у сторінку —
 * приходить фрагментом /?hw_fragment=desktop_menus. Кожен <template data-slot="X">
 * замінює собою порожній .hw-slot[data-slot="X"] у шапці.
 *
 * Забираємо у фоні після load (лише на десктопі), у DOM вставляємо при першій
 * взаємодії з шапкою — наведення, фокус або дотик.
 */
document.addEventListener('DOMContentLoaded', () => {
	const holder = document.querySelector('.hw-menu-fragment[data-fragment-src]');
	const header = document.getElementById('masthead') || holder?.closest('header');
	if (!holder || !header) return;

	let html = null;
	let request = null;
	let injected = false;

	const fetchFragment = () => {
		if (!request) {
			request = fetch(holder.dataset.fragmentSrc, { credentials: 'same-origin' })
				.then((r) => (r.ok ? r.text() : Promise.reject(new Error(r.status))))
				.then((text) => { html = text; })
				.catch(() => { request = null; });
		}
		return request;
	};

	const inject = () => fetchFragment().then(() => {
		if (injected || html === null) return;
		injected = true;
		const box = document.createElement('div');
		box.innerHTML = html;
		box.querySelectorAll('template[data-slot]').forEach((tpl) => {
			const slot = header.querySelector(`.hw-slot[data-slot="${tpl.dataset.slot}"]`);
			if (slot) slot.replaceWith(tpl.content);
		});
		holder.remove();
		document.dispatchEvent(new CustomEvent('helixwave:menus-ready'));
	});

	['pointerenter', 'focusin', 'touchstart'].forEach((type) => {
		header.addEventListener(type, inject, { once: true, passive: true });
	});

	const burger = document.getElementById('burger-btn');
	const prefetch = () => {
		// Десктопні меню показуються лише там, де немає бургера.
		if (burger && burger.offsetParent !== null) return;
		(window.requestIdleCallback || ((cb) => setTimeout(cb, 1500)))(() => fetchFragment(), { timeout: 4000 });
	};
	if (document.readyState === 'complete') prefetch();
	else window.addEventListener('load', prefetch, { once: true });
});
